<template>
	<div id="page">

		<Header></Header>

		<div id="banner" class="pcShow">

			<div class="str_txt">
				<div class="container">
					<div class="str_title">
						<p class="p1">专注更专业</p>
						<p class="p2">品质与产能双保障</p>
					</div>
					<div class="str_num_list">
						<ul>
							<li>
								<b>30<small>+</small></b>
								<p>多年企业历史</p>
							</li>
							<li>
								<b>200<small>+</small></b>
								<p>专业团队</p>
							</li>
							<li>
								<b>100<small>+</small></b>
								<p>台先进设备</p>
							</li>
							<li>
								<b>100<small>+</small></b>
								<p>个行业</p>
							</li>
							<li>
								<b>50000<small>+</small></b>
								<p>个客户</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<img class="mobileShow" :src="imgPrefix + 'static/mobile_strength_banner.jpg'" style="width: 100%;">

		<img class="mobileShow" :src="imgPrefix + 'static/mobile_strength_number.jpg'" style="width: 100%;">

		<div class="changfang">
			<div class="title">厂房介绍</div>
			<img class="mobileShow" :src="imgPrefix + 'static/mobile_strength_img01.jpg'" style="width: 100%;">
			<p style="position: relative;z-index: 99;">惠州得胜彩印有限公司创建于1984年，专注印刷行业30余年，目前已成为国内众多知名品牌企业最值得信任的供应商。厂房占地面积18000
			<br class="pcShow">平方米，坐落于广东省惠州市博罗县，地理位置优越，坐拥穗、港、深一小时经济圈，毗邻香港、澳门特别行政区，交通方便。</p>
			<img class="pcShow" style="width: 100%;margin-top: -70px;" :src="imgPrefix + 'static/strength_img01.jpg'" />
		</div>

		<div class="shebei">
			<div class="container">
				<h2>生产设备</h2>
				<div class="txt">
					<p>公司拥有先进的德国、日本进口印刷设备，先后引进德国进口海德堡五色、四色印刷机，多台轮转机，起钉孔，胶状龙及齐全后序加工配套设备，能以快的速度完成客户的各种印刷要求。可提供集设计、制版、印刷、装订和后道加工为一体的一站式全方位服务。</p>
					<p>强大的研发设计团队，通过不断探索和钻研各种物料和结构的可塑性，结合完善的生产程序及品质管理系统，以满足市场需求。</p>
					<p>为提高印刷品的质量及更好的服务于客户，
						2013年起正式导入PressSIGN印刷质量监测和评分系统，PressSIGN印刷质量评分软件,集监测、控制和修正为一体的印刷质量控制系统，实现了智能化的印刷生产，支持国际化标准ISO12647、GRACoL、SWOP、Japan
						Color、ISO 15339等,GMI认证指定的评分软件。</p>
				</div>

				<div style="position: relative;" class="pcShow">
					<div class="swiper-container swiper-container-1">
						<ul class="swiper-wrapper" v-if="!isIE">
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_01.jpg'">
									<div class="img">
										<img :src="imgPrefix + 'static/shebei_01.jpg'">
									</div>
									<p>小森LS-540印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>

							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_02.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_02.jpg'"></div>
								<p>小森G440印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_03.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_03.jpg'"></div>
								<p>小森E-529印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_04.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_04.jpg'"></div>
								<p>全自动模切机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_05.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_05.jpg'"></div>
								<p>全自动丝网印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_06.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_06.jpg'"></div>
								<p>全自动天地盒流水线 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_07.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_07.jpg'"></div>
								<p>色彩管理系统 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_08.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_08.jpg'"></div>
								<p>手工盒压泡机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_09.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_09.jpg'"></div>
								<p>烫金机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_10.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_10.jpg'"></div>
								<p>圆筒卷边机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_11.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_11.jpg'"></div>
								<p>纸板分纸机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_12.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_12.jpg'"></div>
								<p>纸箱印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_13.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_13.jpg'"></div>
								<p>纸箱装订机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_14.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_14.jpg'"></div>
								<p>自动裱纸机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_15.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_15.jpg'"></div>
								<p>自动高速裱纸机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_16.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_16.jpg'"></div>
								<p>自动糊盒机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
						</ul>
						
						
						<ul class="swiper-wrapper" v-if="isIE">
							<li class="swiper-slide">
								<div class="img">
									<img :src="imgPrefix + 'static/shebei_01.jpg'">
								</div>
								<p>小森LS-540印刷机 <span class="enlarge_btn"></span></p>
							</li>
						
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_02.jpg'"></div>
								<p>小森G440印刷机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_03.jpg'"></div>
								<p>小森E-529印刷机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_04.jpg'"></div>
								<p>全自动模切机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_05.jpg'"></div>
								<p>全自动丝网印刷机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_06.jpg'"></div>
								<p>全自动天地盒流水线 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_07.jpg'"></div>
								<p>色彩管理系统 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_08.jpg'"></div>
								<p>手工盒压泡机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_09.jpg'"></div>
								<p>烫金机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_10.jpg'"></div>
								<p>圆筒卷边机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_11.jpg'"></div>
								<p>纸板分纸机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery" :href="imgPrefix + 'static/shebei_12.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_12.jpg'"></div>
								<p>纸箱印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_13.jpg'"></div>
								<p>纸箱装订机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_14.jpg'"></div>
								<p>自动裱纸机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_15.jpg'"></div>
								<p>自动高速裱纸机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_16.jpg'"></div>
								<p>自动糊盒机 <span class="enlarge_btn"></span></p>
							</li>
						</ul>
					</div>
					<div class="swiper-button-next swiper-button-next-1"></div>
					<div class="swiper-button-prev swiper-button-prev-1"></div>
				</div>
			</div>
		</div>

		<div class="manage mobile_manage mobileShow" style="margin-top: 0;">
			<ul>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_01.jpg'"></div>
					<p>小森LS-540印刷机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_02.jpg'"></div>
					<p>小森G440印刷机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_03.jpg'"></div>
					<p>小森E-529印刷机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_04.jpg'"></div>
					<p>全自动模切机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_05.jpg'"></div>
					<p>全自动丝网印刷机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_06.jpg'"></div>
					<p>全自动天地盒流水线 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_07.jpg'"></div>
					<p>色彩管理系统 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_08.jpg'"></div>
					<p>手工盒压泡机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_09.jpg'"></div>
					<p>烫金机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_10.jpg'"></div>
					<p>圆筒卷边机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_11.jpg'"></div>
					<p>纸板分纸机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_12.jpg'"></div>
					<p>纸箱印刷机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_13.jpg'"></div>
					<p>纸箱装订机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_14.jpg'"></div>
					<p>自动裱纸机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_15.jpg'"></div>
					<p>自动高速裱纸机 <span class="enlarge_btn"></span></p>
				</li>
				<li>
					<div class="img"><img :src="imgPrefix + 'static/shebei_16.jpg'"></div>
					<p>自动糊盒机 <span class="enlarge_btn"></span></p>
				</li>
			</ul>
		</div>

		<div class="capacity">
			<div class="container" style="height: 100%;">
				<div class="img">
					<img :src="imgPrefix + 'static/table.jpg'">
				</div>
				<div class="txt">
					<div>
						<h2>生产设备日产能</h2>
						<p>超过200位专业技术人员服务于得胜彩印各个业务领域，产品涵盖各类精品盒、包装盒、手提纸袋、精装画册、宣传彩页、产品说明书、名片、喷绘、纸箱、展柜等，具有强大的日生产能力。</p>
					</div>
				</div>
			</div>
		</div>

		<div class="system">
			<div class="container">
				<div class="title">色彩管理系统</div>
				<p>为提高印刷品的质量及更好的服务于客户， 2013年起正式导入PressSIGN印刷质量监测和评分系统，PressSIGN印刷质量评分软件,集监测、控制和修正为一体的印刷质量控制系统，
				实现了智能化的印刷生产，支持国际化标准ISO12647、GRACoL、SWOP、Japan Color、ISO 15339等,GMI认证指定的评分软件。</p>
				<div class="img">
					<img :src="imgPrefix + 'static/system-01.jpg'">
				</div>
				<div class="img">
					<img :src="imgPrefix + 'static/system-02.jpg'">
				</div>
			</div>
		</div>

		<div class="manage">
			<div class="container">
				<h3 class="mobileShow">严格的质量管理体系</h3>
				<div class="bigimg">
					<img :src="imgPrefix + 'static/strength_img02.jpg'">
				</div>
				<div class="txt">
					<h2 class="pcShow">严格的质量管理体系</h2>
					<p>公司依据ISO9001:2015版质量管理体系的要求，建立完善的质量管理体系作为公司质量管理的准则，并以“市场导向、技术核心、优质服务、守约重信、保护环境、预防污染、员工健康、安全生产”的方针，确定公司质量管理的宗旨和发展方向，有效实施质量管理体系，并持续改进产品质量及服务质量，满足更多的客户。</p>
					<p>在来料、过程、成品各管控环节，进行层层检测管控的严密检验流程，检验人员依据内部检验标准对各环节进行严格检验。拥有专业品质工程师、技术员和质检人员100余人，先进生产、检测设备100余台，组成了一支高素质、严要求的强大品管保证队伍，利用科学的检测手段，对产品进行严格的检验和监控。</p>
				</div>
			</div>

			<div class="container">
				<div style="position: relative;margin-top: 65px;" class="pcShow">
					<div class="swiper-container swiper-container-2">
						<ul class="swiper-wrapper" v-if="!isIE">
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_21.JPG'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_21.JPG'"></div>
								<p>纸张取样仪 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_22.JPG'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_22.JPG'"></div>
								<p>边压强度试验仪 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_23.JPG'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_23.JPG'"></div>
								<p>纸张弯曲挺度测定仪 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_24.JPG'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_24.JPG'"></div>
								<p>CTP版打孔机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_25.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_25.jpg'"></div>
								<p>半自动覆膜机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_26.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_26.jpg'"></div>
								<p>半自动糊箱机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_27.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_27.jpg'"></div>
								<p>半自动手工盒流水线 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_28.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_28.jpg'"></div>
								<p>半自动贴窗流水线 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_29.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_29.jpg'"></div>
								<p>裱卡机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_30.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_30.jpg'"></div>
								<p>不干胶印刷机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_31.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_31.jpg'"></div>
								<p>过胶机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_32.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_32.jpg'"></div>
								<p>介样机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_33.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_33.jpg'"></div>
								<p>开槽切角机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_34.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_34.jpg'"></div>
								<p>模切机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_35.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_35.jpg'"></div>
								<p>磨刀机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_36.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_36.jpg'"></div>
								<p>切纸机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_37.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_37.jpg'"></div>
								<p>全自动UV上光机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_38.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_38.jpg'"></div>
								<p>全自动糊盒机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
							<li class="swiper-slide">
								<a data-fancybox="gallery2" :href="imgPrefix + 'static/shebei_39.jpg'">
								<div class="img"><img :src="imgPrefix + 'static/shebei_39.jpg'"></div>
								<p>CTP出版机 <span class="enlarge_btn"></span></p>
								</a>
							</li>
						</ul>
						
						
						<ul class="swiper-wrapper" v-if="isIE">
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_21.JPG'"></div>
								<p>纸张取样仪 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_22.JPG'"></div>
								<p>边压强度试验仪 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_23.JPG'"></div>
								<p>纸张弯曲挺度测定仪 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_24.JPG'"></div>
								<p>CTP版打孔机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_25.jpg'"></div>
								<p>半自动覆膜机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_26.jpg'"></div>
								<p>半自动糊箱机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_27.jpg'"></div>
								<p>半自动手工盒流水线 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_28.jpg'"></div>
								<p>半自动贴窗流水线 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_29.jpg'"></div>
								<p>裱卡机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_30.jpg'"></div>
								<p>不干胶印刷机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_31.jpg'"></div>
								<p>过胶机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_32.jpg'"></div>
								<p>介样机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_33.jpg'"></div>
								<p>开槽切角机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_34.jpg'"></div>
								<p>模切机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_35.jpg'"></div>
								<p>磨刀机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_36.jpg'"></div>
								<p>切纸机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_37.jpg'"></div>
								<p>全自动UV上光机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_38.jpg'"></div>
								<p>全自动糊盒机 <span class="enlarge_btn"></span></p>
							</li>
							<li class="swiper-slide">
								<div class="img"><img :src="imgPrefix + 'static/shebei_39.jpg'"></div>
								<p>CTP出版机 <span class="enlarge_btn"></span></p>
							</li>
						</ul>
					</div>
					<div class="swiper-button-next swiper-button-next-2"></div>
					<div class="swiper-button-prev swiper-button-prev-2"></div>
				</div>
			</div>

			<div class="mobile_manage mobileShow">
				<ul>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_21.JPG'"></div>
						<p>纸张取样仪 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_22.JPG'"></div>
						<p>边压强度试验仪 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_23.JPG'"></div>
						<p>纸张弯曲挺度测定仪 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_24.JPG'"></div>
						<p>CTP版打孔机 <span class="enlarge_btn"></span></p>
					</li>

					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_25.jpg'"></div>
						<p>半自动覆膜机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_26.jpg'"></div>
						<p>半自动糊箱机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_27.jpg'"></div>
						<p>半自动手工盒流水线 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_28.jpg'"></div>
						<p>半自动贴窗流水线 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_29.jpg'"></div>
						<p>裱卡机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_30.jpg'"></div>
						<p>不干胶印刷机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_31.jpg'"></div>
						<p>过胶机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_32.jpg'"></div>
						<p>介样机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_33.jpg'"></div>
						<p>开槽切角机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_34.jpg'"></div>
						<p>模切机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_35.jpg'"></div>
						<p>磨刀机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_36.jpg'"></div>
						<p>切纸机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_37.jpg'"></div>
						<p>全自动UV上光机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_38.jpg'"></div>
						<p>全自动糊盒机 <span class="enlarge_btn"></span></p>
					</li>
					<li class="swiper-slide">
						<div class="img"><img :src="imgPrefix + 'static/shebei_39.jpg'"></div>
						<p>CTP出版机 <span class="enlarge_btn"></span></p>
					</li>
				</ul>
			</div>
		</div>

		<Footer></Footer>

	</div>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	export default {
    data() {
      return {
		isIE:false,
        imgPrefix: process.env.PREFIX_IMG,
      }
    },
		components: {
			Header,
			Footer
		},
		mounted() {
			new Swiper('.swiper-container-1', {
				// loop: true,
				autoplay: true,
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 25,
				autoplay: 2000,
				nextButton: '.swiper-button-next-1',
				prevButton: '.swiper-button-prev-1',
			})
			new Swiper('.swiper-container-2', {
				// loop: true,
				autoplay: true,
				autoplay: 2000,
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 25,
				nextButton: '.swiper-button-next-2',
				prevButton: '.swiper-button-prev-2',
			})
			if(navigator.appName == "Microsoft Internet Explorer"&&parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE",""))<10){
			   this.isIE = true;
			}
		},
		methods: {

		},
	}
</script>

<style scoped="">
	@media (min-width: 1440px){
		.container, .container-sm, .container-md, .container-lg, .container-xl {
		    max-width: 1320px !important;
		}
	}


	.system{
		margin: 60px 0;
		min-height: 0;
		overflow: hidden;
	}
	.system .img{
		float: left;
		width: 50.35%;
	}
	.system .img img{
		width: 100%;
	}
	.system .img:last-child{
		float: right;
		width: 46.1%;
	}
	.system .title{
		font-size: 42px;
		color: #333333;
		margin-bottom: 13px;
	}
	.system p{
		font-size: 17px;
		color: #333333;
		line-height: 30px;
		text-indent: 34px;
	}

	.manage ul li p{
		line-height: 45px;
		background: #eeeeee;
		position: relative;
		text-indent: 20px;
	}
	.manage ul li img{
	    width: 100%;
		height: auto;
	}
	.manage ul li{
	    float: left;
	}
	.manage {
		min-height: 0;
		overflow: hidden;
		margin: 100px 0 85px 0;
	}

	.manage .bigimg {
		float: left;
		margin-right: 60px;
	}

	.manage .bigimg img{
		width: 100%;
	}

	.manage .txt h2 {
		font-size: 42px;
		color: #333333;
		margin-bottom: 36px;
		padding-top: 15px;
	}

	.manage .txt {
		padding-right: 90px;
	}

	.manage .txt p {
		font-size: 16px;
		color: #333333;
		line-height: 30px;
		text-indent: 32px;
	}

	#banner {
		height: 600px;
		background: url('https://img.ds-cy.com/static/strength_banner.jpg') no-repeat;
		background-position: top center;
	}

	.changfang {
		text-align: center;
		margin-top: 110px;
	}

	.changfang .title {
		font-size: 35px;
		color: #000000;
		letter-spacing: 1px;
		margin-bottom: 40px;
	}

	.changfang p {
		font-size: 17px;
		color: #666666;
		line-height: 32px;
	}

	.shebei {
		margin-top: 70px;
		min-height: 0;
		overflow: hidden;
		margin-bottom: 70px;
	}

	.shebei ul {
		/* margin-left: 65px; */
		margin-top: 50px;
		width: 90%;
	}

	.swiper-button-prev {
		width: 21px !important;
		height: 67px !important;
		background: url('https://img.ds-cy.com/static/prev_btn.jpg') !important;
		left: -50px;
		outline: none;
	}

	.swiper-button-next {
		width: 21px !important;
		height: 67px !important;
		background: url('https://img.ds-cy.com/static/next_btn.jpg') !important;
		right: -50px;
		outline: none;
	}

	.shebei h2 {
		font-size: 35px;
		color: #333333;
		margin-bottom: 20px;
	}

	.shebei .txt p {
		font-size: 17px;
		color: #333333;
		line-height: 32px;
		text-indent: 34px;
	}

	.shebei ul li {
		width: 22.2%;
		float: left;
		margin-right: 1.8%;
	}

	.shebei ul li a{
		outline: none;
		color: inherit;
	}

	.shebei ul li p {
		line-height: 45px;
		background: #eeeeee;
		position: relative;
		text-indent: 20px;
	}

	.shebei ul li img {
		width: 100%;
		height: auto;
	}

	.enlarge_btn {
		position: absolute;
		width: 26px;
		height: 26px;
		background: url('https://img.ds-cy.com/static/enlarge.jpg');
		right: 10px;
		top: 10px;
	}

	.capacity {
		height: 482px;
		background: #eeeeee;
		overflow: hidden;
	}

	.capacity .img {
		width: 57%;
		float: left;
	}

	.capacity .img img {
		max-width: 100%;
	}

	.capacity .txt {
		width: 43%;
		float: right;
		background: #00a0e9;
		height: 100%;
		position: relative;
	}

	.capacity .txt>div {
		position: absolute;
		z-index: 999;
		padding-left: 65px;
		top: 50%;
		-webkit-transform: translate(0, -50%);
		-ms-transform: translate(0, -50%);
		-o-transform: translate(0, -50%);
		padding-right: 105px;
	}

	.capacity .txt::after {
		content: '';
		width: 1000px;
		position: absolute;
		left: 0;
		height: 100%;
		background: #00a0e9;
		top: 0;
	}

	.capacity .txt h2 {
		color: #fff;
		font-size: 35px;
		letter-spacing: 2px;
		margin-bottom: 25px;
	}

	.capacity .txt p {
		color: #fff;
		font-size: 17px;
		line-height: 30px;
		text-indent: 34px;
		margin-bottom: 0;
	}

	.str_txt{
		text-align: center;

	}

	.str_txt .p1{
		padding-top: 125px;
		font-size: 55px;
		margin-bottom: -5px;
	}

	.str_txt p{
		color: #fff;
	}

	.str_txt p.p2{
		font-size: 55px;
		font-weight: bold;
		position: relative;
		padding-bottom: 22px;
	}

	.str_txt p.p2::after{
		position: absolute;
		content: '';
		height: 2px;
		background: #ff9900;
		width: 90px;
		bottom: 0;
		left: 50%;
		margin-left: -45px;
	}

	.str_num_list{
		margin-top: 110px;
	}

	.str_num_list ul li{
		width: 20%;
		float: left;
		text-align: center;
	}

	.str_num_list ul li b{
		color: #ff9900;
		font-size: 54px;
		text-indent: 10px;
		display: block;
	}

	.str_num_list ul li small{
		font-size: 27px;
		position: relative;
		top: -25px;
		margin-left: 2px;
	}

	.str_num_list ul li p{
		font-size: 18px;
	}

	.manage ul li a{
		color: initial;
		outline: none;
	}
	
	@media (max-width:1024px) {
		.manage .txt{
			padding-right: 0;
		}
		.manage .bigimg{
			width: 100%;
			margin-bottom: 30px;
		}
		.swiper-button-next{
			right: -33px;
		}
		.swiper-button-prev{
			left: -33px;
		}
	}
	
	@media (max-width:991px) {
		
		.shebei ul li p{
			text-indent: 8px;
			font-size: 14px;
		}
		.manage ul li p{
			text-indent: 8px;
			font-size: 14px;
		}
		
		.capacity .txt>div{
			padding-right: 0;
			padding-left: 30px;
		}
		.capacity .txt h2{
			font-size: 24px;
			    margin-bottom: 15px;
		}
		.capacity{
			height: 300px;
		}
		.capacity .txt p{
			font-size: 16px;
			    line-height: 28px;
		}
		.manage .bigimg{
			margin-right: 0;
		}
		.str_num_list ul li b{
			font-size: 35px;
		}
	}

	@media (max-width:767px) {
		.capacity{
			height: 482px;
		}
		.capacity .img{
			width: 100%;
		}
		.capacity .txt{
			width: 100%;
		}
		.capacity .txt>div{
			position: initial;
			-webkit-transform: translate(0, 0);
			padding-right: 0;
		}
		.changfang{
			margin-top: 35px;
			margin-left: 15px;

			margin-right: 15px;
		}
		.changfang p{
			background: #00a0e9;
			text-align: left;
			color: #fff;
			font-size: 14px;
			line-height: 22px;
			padding: 15px;
		}
		.changfang .title{
			font-size: 24px;
			margin-bottom: 15px;
		}
		.shebei h2{
			font-size: 24px;
			margin-bottom: 15px;
		}
		.shebei .txt p{
			font-size: 15px;
			color: #333333;
			line-height: 24px;
			text-indent: 32px;
			margin-bottom: 6px;
		}
		.shebei{
			margin-top: 40px;
			margin-bottom: 12px;
		}
		.system .title{
			font-size: 24px;
			text-align: center;
		}
		.system p{
			font-size: 15px;
			color: #333333;
			line-height: 24px;
			text-indent: 32px;
			margin-bottom: 20px;
		}
		.manage{
			margin: 0 0 40px 0;
		}
		.manage .bigimg{
			margin-right: 0;
			margin-bottom: 18px;
		}
		.manage .txt{
			padding-right: 0;
		}
		.manage h3{
			text-align: center;
			font-size: 24px;
			margin-bottom: 22px;
		}
		.system{
			margin: 35px 0;
			/* margin-top: -40px; */
		}
		.manage .txt p{
			font-size: 15px;
			color: #333333;
			line-height: 24px;
			text-indent: 32px;
			margin-bottom: 15px;
		}
		.capacity .txt{
			position: initial;
			height: auto;
		}
		.capacity{
			background: #fff;
		}
		.capacity .txt>div{
			padding-left: 0;
			padding: 5%;
		}
		.capacity .txt h2{
			font-size: 22px;
			margin-bottom: 10px;
		}
		.capacity .txt p{
		    font-size: 15px;
		    line-height: 24px;
			margin-bottom: 0;
		    text-indent: 32px;
		}
		.capacity .txt::after{
			display: none;
		}
		.mobile_manage{
			margin-top: 20px;
			margin-left: 15px;

		}
		.manage{
			margin-bottom: 16px;
		}
		.mobile_manage ul {
			white-space: nowrap;
			overflow-x: scroll;
			width: 100%;
			display: block;
			padding-right: 0;
		}
		.mobile_manage ul li {
		    display: inline-block;
		    white-space: initial;
		    width: 200px;
		    margin-right: 7px;
			float: inherit;
		}
		.enlarge_btn{
			display: none;
		}
		.manage ul li p{
			line-height: 38px;
			text-indent: 15px;
			font-size: 15px;
		}

		.capacity .img{
			background: #eee;
		}
		.capacity .img img{
			padding: 0 6px;
			margin-top: -10px;
			margin-bottom: -10px;
		}
	}
	
	
	
	@media (max-width:500px) {
		.system{
			margin-top: -40px; 
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/strength.html.vue